import {history} from '../../../history'
import {store} from '../../utilities'

export default function onRow(record, setListFilters) {
  return {
    style: {cursor: `pointer`},
    onClick: (e) => {
      if (e.metaKey) return window.open(`/users/${record.id}/manage`)
      const state = store.getState()
      if (setListFilters) {
        setListFilters((prevFilters) => ({
          ...prevFilters,
          type: "users", 
          query : { 
            status : state?.query?.status || null,
            fullTextQuery: state?.query?.fullTextQuery || null,
            filters: state?.query?.filters || null,
            from: state?.query?.from || 0
          }, // Resetting the filter
          tableControls: {
            sorter: state?.tableControls?.sorter || null,
            pagination: state?.tableControls?.pagination || null
          }
        }))
      }
      history.push(`/users/${record.id}/manage`)
    },
  }
}
